import { createContext, useContext, type ReactNode } from 'react';

export type StaffRolesMap = Record<string, Record<string, boolean>>;

const StaffRolesContext = createContext<StaffRolesMap>({});

interface StaffRolesProviderProps {
  roles: StaffRolesMap;
  children: ReactNode;
}

export function StaffRolesProvider({ roles, children }: StaffRolesProviderProps) {
  return <StaffRolesContext.Provider value={roles}>{children}</StaffRolesContext.Provider>;
}

export function useStaffRoles(): StaffRolesMap {
  return useContext(StaffRolesContext);
}
